module.exports = __webpack_public_path__ + "img/acad58f0ea8a4fe09012041d4d19b694_mergeImage.58e03bad.png";